import { useState, useMemo, useCallback, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { addGeoTagLocationAssign, getGeoTagLocation, removeGeoTagLocationAssign } from './Services/AttendanceService';
import { GetMasterTypeData } from '../../../Services/Global-Services/GlobalServices';
import { getEmployeeList } from '../EmployeeList/Service/employeeService';
import { TostMsg } from '../../../App';

const Geotag_Employee_Assignment = () => {
  const [currentMode, setCurrentMode] = useState('all');
  const [selectedAllMode, setSelectedAllMode] = useState(null);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [mgrSearch, setMgrSearch] = useState('');
  const [locations, setLocations] = useState([]);
  const [zoneCategoryType, setZoneCategoryType] = useState([])
  const [regionCategoryType, setRegionCategoryType] = useState([])
  const [loading, setLoading] = useState(false);
  const { LocationAssignedId } = useParams();
  const [reportingHirechy, setReportingHirechy] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedManagerId, setSelectedManagerId] = useState(null);
  const zoneEmpCount = 0;
  const [selectedManager, setSelectedManager] = useState(null);
  const defaultImage = "/images/placeholder_profile.png";
  const toster = useContext(TostMsg);


  useEffect(() => {
    gettGeoTagLocationList()
    ReportOrHierarchy(0)
  }, [])


  useEffect(() => {
    if (locations?.OrgId) {
      getGeoTagRegionCategory();
      getMasterTicketCategory();
    }
  }, [locations])

  useEffect(() => {
    const handleClickOutside = () => setShowSuggestions(false);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSelectZone = (zone) => {
    setSelectedZone(zone);
    setSelectedRegion(null); // reset region when zone changes
  };

  const handleSelectRegion = (region) => {
    setSelectedRegion(region); // only one allowed
  };

  const regionsByZone = useMemo(() => {
    const map = {};

    regionCategoryType.forEach((r) => {
      const key = Number(r.Code); // zone.Id
      if (!map[key]) map[key] = [];
      map[key].push(r);
    });

    return map;
  }, [regionCategoryType]);




  const relevantRegions = useMemo(() => {
    if (!selectedZone) return [];
    return regionsByZone[selectedZone.Id] || [];
  }, [selectedZone, regionsByZone]);


  const handleSearchChange = (value) => {
    setSearchValue(value);

    if (!value.trim()) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const filtered = reportingHirechy.filter((emp) =>
      emp.FullName?.toLowerCase().includes(value.toLowerCase())
    );

    setSuggestions(filtered);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (emp) => {
    setSearchValue(emp.FullName);
    setSelectedManager(emp);   // ✅ store full object
    setSelectedManagerId(emp.EmpId);
    setShowSuggestions(false);
  };

  async function ReportOrHierarchy(employeeId) {
    const params1 = {
      OrganisationId: userDetails?.OrgId ?? 101,
      LoggedInEmployeeId: userDetails?.EmpId ?? 101,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: employeeId ?? 0,
      IsSuggestedOnly: 0,
    };

    try {
      let res = await getEmployeeList(params1);
      const list = res?.Data || [];
      setReportingHirechy(list);
    } catch (error) {
      console.error(error);
    }
  }



  async function gettGeoTagLocationList() {
    setLoading(true);
    const params = {
      Id: 0,
      PageNumber: 1,
      PageSize: 1,
      GUID: LocationAssignedId || "",
      Search: "",
    };

    try {
      const response = await getGeoTagLocation(params);
      setLoading(false);
      setLocations(response?.Data?.[0] || {});
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLoading(false);
    }
  }



  async function addLocationAssign(TypeId, TargetId) {

    setLoading(true);

    const params = {
      TypeId,
      TargetId,
      LocationId: locations?.Id
    };

    try {
      const response = await addGeoTagLocationAssign(params);
      setLoading(false);
      gettGeoTagLocationList()
      if (response?.StatusCode == 2999) {
        toster.current.error(response?.Message);
        return;
      } else {
        toster.current.success("Assigned successfully");
      }

      setLocations(response?.Data?.[0] || {});
      setSelectedAllMode(null);
      setSelectedZone(null);
      setSelectedRegion(null);
      setMgrSearch('');
      setSelectedEmployee(null);
      setSearchValue("");
      setSelectedManager(null);
      setSelectedManagerId(null);
      // toster.current.success("Assigned successfully");

    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      toster.current.error("Something went wrong");
    }
  }

  async function removeLocationAssign(TypeId, TargetId) {
    setLoading(true);

    const params = {
      TypeId,
      TargetId,
      LocationId: locations?.Id
    };

    try {
      const response = await removeGeoTagLocationAssign(params);
      setLoading(false);
      gettGeoTagLocationList()
      // ❌ Don't assume success
      if (response?.StatusCode == 2999) {
        toster.current.error(response?.Message);
        return;
      } else {
        toster.current.success("Removed successfully");
      }

      // ✅ Success case
      setLocations(response?.Data?.[0] || {});
      setSelectedAllMode(null);
      setSelectedZone(null);
      setSelectedRegion(null);
      setMgrSearch('');
      setSelectedEmployee(null);
      setSearchValue("");
      setSelectedManager(null);
      setSelectedManagerId(null);

      //  toster.current.success("Removed successfully");

    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      toster.current.error("Something went wrong");
    }
  }

  async function getGeoTagRegionCategory() {
    const params = {
      organisationId: locations?.OrgId ?? 101,
      masterType: "OrgRegion",
    };
    try {
      const data = await GetMasterTypeData(params);
      setRegionCategoryType(data?.Data || []);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: locations?.OrgId ?? 101,
      masterType: "OrgZone",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setZoneCategoryType(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const switchMode = (mode) => {
    setCurrentMode(mode);
    setSelectedAllMode(null);
    setSelectedZone(null);     // ✅ reset
    setSelectedRegion(null);   // ✅ reset
    setMgrSearch('');
    setSelectedEmployee(null);
    setSearchValue("");
    setSelectedManager(null);
  };

  const handleSelectAllMode = (type) => {
    setSelectedAllMode(type);
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const handleSaveAssignments = () => {
    setShowSaveBtn(false);
  };

  return (
    <div>
      <div className="container-fluid">
        {/* Breadcrumb */}
        <div style={{ fontSize: '.76rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
          <a href="#" style={{ color: 'var(--primary)', textDecoration: 'none' }}>Attendance</a>
          <i className="fa fa-chevron-right" style={{ fontSize: '.6rem', margin: '0 .4rem' }}></i>
          <a href="#" style={{ color: 'var(--primary)', textDecoration: 'none' }}>Geo Tag Locations</a>
          <i className="fa fa-chevron-right" style={{ fontSize: '.6rem', margin: '0 .4rem' }}></i>
          <span>Delhi Tech Hub</span> — Employee Assignment
        </div>


        {/* Page head */}
        <div className="page-head" style={{ marginBottom: '1rem' }}>
          <div>
            <h2>Employee Assignment</h2>
            <p>Choose an assignment mode and select employees to link to this geo tag location</p>
          </div>
          <div className="head-actions">
            <button className="btn-og btn-og-secondary btn-og-sm" onClick={() => window.history.back()}>
              <i className="fa fa-arrow-left"></i> Back
            </button>
            {showSaveBtn && (
              <button className="btn-og btn-og-primary btn-og-sm" onClick={handleSaveAssignments}>
                <i className="fa fa-save"></i> Save All Changes
              </button>
            )}
          </div>
        </div>

        <div className="dual-panel">
          <div>
            <div className="mode-tabs">
              {[
                { id: 'all', label: 'All Employees', icon: 'fa-users' },
                { id: 'zone', label: 'By Zone / Region', icon: 'fa-globe' },
                { id: 'manager', label: 'By Manager', icon: 'fa-sitemap' },
                { id: 'individual', label: 'Individual', icon: 'fa-user-plus' },
              ].map(tab => (
                <button
                  key={tab.id}
                  className={`mode-tab ${currentMode === tab.id ? 'active' : ''}`}
                  onClick={() => {
                    switchMode(tab.id);

                    if (tab.id === 'manager') {
                      ReportOrHierarchy(userDetails?.EmpId);
                    } else if (tab.id === 'individual') {
                      ReportOrHierarchy(0);
                    }
                  }}
                >
                  <i className={`fa ${tab.icon}`}></i>
                  <span className="tab-label">{tab.label}</span>
                </button>
              ))}
            </div>

            {/* Bulk action banner */}

            {/* {currentMode === 'individual' && indSelections.size > 0 && (
              <div className="bulk-banner show">
                <i className="fa fa-check-square-o"></i>
                <span>{indSelections.size} employee{indSelections.size !== 1 ? 's' : ''} selected</span>
                <button className="btn-og btn-og-primary btn-og-sm" onClick={handleAddSelected}>
                  <i className="fa fa-plus"></i> Add Selected
                </button>
                <button className="btn-og btn-og-secondary btn-og-sm" onClick={() => setIndSelections(new Set())}>
                  <i className="fa fa-times"></i> Clear
                </button>
              </div>
            )} */}

            {/* MODE: ALL EMPLOYEES */}
            {currentMode === 'all' && (
              <div className={`mode-content og-card ${currentMode === 'all' ? 'active' : ''}`} style={{ overflow: 'visible' }}>
                <div className="og-card-header">
                  <div>
                    <h5><i className="fa fa-users" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>All Employees</h5>
                    <div className="sub">Assign all employees or use filters to narrow down</div>
                  </div>
                </div>
                <div className="og-card-body">
                  <div style={{ background: '#fff8f0', border: '1px solid #fcd9c5', borderRadius: '8px', padding: '.65rem .85rem', marginBottom: '1rem', fontSize: '.77rem', color: '#c94a00', display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                    <i className="fa fa-exclamation-triangle"></i>
                    This will assign <strong>all employees</strong> to this geo tag location. Only do this if all employees work from this location.
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '.75rem', marginBottom: '1rem' }}>
                    {[
                      { type: 'all', label: 'All Employees', icon: 'fa-users', color: 'var(--primary)', desc: 'Assign everyone' }
                    ].map(opt => (
                      <div
                        key={opt.type}
                        onClick={() => handleSelectAllMode(opt.type)}
                        style={{
                          border: selectedAllMode === opt.type ? '1.5px solid var(--primary)' : '1.5px solid var(--border)',
                          borderRadius: '9px',
                          padding: '.85rem',
                          textAlign: 'center',
                          cursor: 'pointer',
                          transition: 'all .15s',
                          background: selectedAllMode === opt.type ? 'var(--primary-light)' : ''
                        }}
                      >
                        <i className={`fa ${opt.icon}`} style={{ fontSize: '1.5rem', color: opt.color, display: 'block', marginBottom: '.4rem' }}></i>
                        <div style={{ fontWeight: 700, fontSize: '.84rem' }}>{opt.label}</div>
                        <div style={{ fontSize: '.7rem', color: 'var(--text-muted)' }}>{opt.desc}</div>
                      </div>
                    ))}
                  </div>
                  <div className='geo-buttons'>
                    <button
                      className="btn-og btn-brand"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedAllMode}
                      onClick={() => addLocationAssign(1, 0)}
                    >
                      <i className="fa fa-check"></i>
                      <span>
                        {selectedAllMode
                          ? 'Assign all employees to this location'
                          : 'Select option to proceed'}
                      </span>
                    </button>
                    <button
                      className="btn-og btn-og-primary"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedAllMode}
                      onClick={() => removeLocationAssign(1, 0)}
                    >
                      <i className="fa fa-check"></i>
                      <span>
                        {selectedAllMode
                          ? 'Remove all employees from this location'
                          : 'Select option to proceed'}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* MODE: ZONE / REGION */}
            {currentMode === 'zone' && (
              <div className={`mode-content og-card ${currentMode === 'zone' ? 'active' : ''}`} style={{ overflow: 'visible' }}>
                <div className="og-card-header">
                  <div>
                    <h5><i className="fa fa-globe" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>By Zone / Region</h5>
                    <div className="sub">Select one or more zones or regions to assign all employees within</div>
                  </div>
                </div>
                <div className="og-card-body">
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ fontSize: '.77rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: '.65rem' }}>Select Zones</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.6rem' }}>
                      {zoneCategoryType.map(z => (
                        <div
                          key={z.Id}
                          className={`zone-card ${selectedZone?.Id === z.Id ? 'selected' : ''}`}
                          onClick={() => handleSelectZone(z)}
                        >
                          <div className="zc-icon">
                            <i className="fa fa-globe"></i>
                          </div>

                          <div>
                            <div className="zc-name">{z.Name}</div>
                            {/* <div className="zc-sub">
                              {(regionsByZone[z.Code]?.length || 0)} regions
                            </div> */}
                          </div>

                          <div className="zc-check">
                            {selectedZone?.Id === z.Id && <i className="fa fa-check"></i>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {selectedZone && (
                    <div style={{ marginBottom: '1rem' }}>
                      <div style={{ fontSize: '.77rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: '.65rem' }}>Select Regions (within chosen zones)</div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '.5rem' }}>
                        {relevantRegions.map(r => (
                          <div
                            key={r.Id}
                            className={`zone-card ${selectedRegion?.Id === r.Id ? 'selected' : ''}`}
                            onClick={() => handleSelectRegion(r)}
                          >
                            <div className="zc-icon" style={{ width: '28px', height: '28px', fontSize: '.75rem' }}>
                              <i className="fa fa-map-marker"></i>
                            </div>

                            <div>
                              <div className="zc-name" style={{ fontSize: '.78rem' }}>
                                {r.Name}
                              </div>
                              {/* <div className="zc-sub">Code: {r.Code}</div> */}
                            </div>

                            <div className="zc-check" style={{ width: '18px', height: '18px' }}>
                              {selectedRegion?.Id === r.Id && <i className="fa fa-check"></i>}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {selectedZone && (
                    <div style={{ marginTop: '1rem' }}>
                      <strong>Employees</strong> will be assigned ·
                      {selectedRegion
                        ? `Region: ${selectedRegion.Name}`
                        : `Zone: ${selectedZone.Name}`}
                    </div>
                  )}
                  <div className='geo-buttons'>
                    <button
                      className="btn-og btn-brand"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedZone}
                      onClick={() => {
                        if (selectedRegion) {
                          // ✅ region selected
                          addLocationAssign(3, selectedRegion.Id);
                        } else {
                          // ✅ only zone
                          addLocationAssign(2, selectedZone.Id);
                        }
                      }}
                    >
                      <i className="fa fa-check"></i>
                      <span>Assign Employees from Selected Area</span>
                    </button>
                    <button
                      className="btn-og btn-og-primary"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedZone}
                      onClick={() => {
                        if (selectedRegion) {
                          // ✅ region selected
                          removeLocationAssign(3, selectedRegion.Id);
                        } else {
                          // ✅ only zone
                          removeLocationAssign(2, selectedZone.Id);
                        }
                      }}
                    >
                      <i className="fa fa-check"></i>
                      <span>Remove Employees from Selected Area</span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* MODE: BY MANAGER */}
            {currentMode === 'manager' && (
              <div className={`mode-content og-card ${currentMode === 'manager' ? 'active' : ''}`} style={{ overflow: 'visible' }}>
                <div className="og-card-header">
                  <div>
                    <h5><i className="fa fa-sitemap" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>By Manager / Reporting Hierarchy</h5>
                    <div className="sub">Select a manager to assign all employees reporting to them</div>
                  </div>
                </div>
                <div className="og-card-body">
                  <div style={{ position: 'relative', marginBottom: '1rem' }}>
                    <i className="fa fa-search" style={{ position: 'absolute', left: '.7rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '.78rem' }}></i>
                    <input
                      type="text"
                      className="og-input"
                      placeholder="Search name"
                      style={{ paddingLeft: '2rem' }}
                      value={searchValue}
                      onChange={(e) => handleSearchChange(e.target.value)}
                      onFocus={() => searchValue && setShowSuggestions(true)}
                    />
                    {showSuggestions && suggestions.length > 0 && (
                      <ul className="suggestion-box">
                        {suggestions.map((emp) => (
                          <li
                            key={emp.EmpId}
                            onClick={() => handleSuggestionClick(emp)}
                          >
                            <img src={emp?.ProfileImage || defaultImage}
                              onError={handleImageError} width="18" height="18" style={{ borderRadius: '100%', marginRight: '5px' }} />{emp.FullName}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div style={{ fontSize: '.75rem', color: 'var(--text-muted)', marginBottom: '.65rem' }}>
                    <i className="fa fa-info-circle" style={{ marginRight: '.3rem' }}></i>
                    Click a manager row to select all their direct reports.
                  </div>
                  {selectedManager && (
                    <div style={{
                      marginBottom: '.7rem',
                      padding: '.5rem .7rem',
                      background: '#f1f5f9',
                      borderRadius: '6px',
                      fontSize: '.8rem'
                    }}

                    >
                      Selected: <strong>{selectedManager.FullName}</strong>
                      <span
                        style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', float: ' right' }}
                        onClick={() => {
                          setSelectedManager(null);
                          setSelectedManagerId(null);
                          setSearchValue("");
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  )}
                  <div className='geo-buttons'>
                    <button
                      className="btn-og btn-brand"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedManagerId}
                      onClick={() => addLocationAssign(4, selectedManagerId)}
                    >
                      <i className="fa fa-check"></i>
                      <span> Employees Under a manager to proceed</span>
                    </button>

                    <button
                      className="btn-og btn-og-primary"
                      style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
                      disabled={!selectedManagerId}
                      onClick={() => removeLocationAssign(4, selectedManagerId)}
                    >
                      <i className="fa fa-check"></i>
                      <span> Employees Under a manager to proceed</span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* MODE: INDIVIDUAL */}
            {currentMode === 'individual' && (
              <div className={`mode-content og-card ${currentMode === 'individual' ? 'active' : ''}`} style={{ overflow: 'visible' }}>
                <div className="og-card-header">
                  <div>
                    <h5>
                      <i className="fa fa-user-plus" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>
                      Individual Employee Selection
                    </h5>
                    <div className="sub">Search and select specific employees one by one or in batches</div>
                  </div>
                </div>

                <div className="og-card-body" style={{ paddingTop: '.75rem' }}>
                  <div style={{ display: 'flex', gap: '.6rem', flexWrap: 'wrap', marginBottom: '.85rem' }}>

                    {/* Zone */}
                    {/* <select
                      className="og-select"
                      value={selectedZone || ""}
                      onChange={(e) => setSelectedZone(Number(e.target.value))}
                    >
                      <option value="">All Zones</option>
                      {zoneCategoryType.map((zone) => (
                        <option key={zone.Id} value={zone.Id}>
                          {zone.Name}
                        </option>
                      ))}
                    </select> */}

                    {/* Region */}
                    {/* <select
                      className="og-select"
                      value={selectedRegion}
                      onChange={(e) => setSelectedRegion(e.target.value)}
                    >
                      <option value="">All Region</option>
                      {regionCategoryType.map((region) => (
                        <option key={region.Id} value={region.Id}>
                          {region.Name}
                        </option>
                      ))}
                    </select> */}

                    {/* Search */}
                    <div style={{ position: 'relative', flex: 1, minWidth: '160px' }}>
                      <i
                        className="fa fa-search"
                        style={{
                          position: 'absolute',
                          left: '.65rem',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: 'var(--text-muted)',
                          fontSize: '.78rem'
                        }}
                      ></i>

                      <input
                        type="text"
                        className="og-input"
                        placeholder="Search name"
                        style={{ paddingLeft: '2rem' }}
                        value={searchValue}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        onFocus={() => searchValue && setShowSuggestions(true)}
                      />

                      {showSuggestions && suggestions.length > 0 && (
                        <ul className="suggestion-box">
                          {suggestions.map((emp) => (
                            <li
                              key={emp.EmpId}
                              onClick={() => {
                                setSearchValue(emp.FullName);
                                setSelectedEmployee(emp);   // ✅ store employee
                                setShowSuggestions(false);
                              }}
                            >
                              <img src={emp?.ProfileImage || defaultImage}
                                onError={handleImageError} width="18" height="18" style={{ borderRadius: '100%', marginRight: '5px' }} />{emp.FullName}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  {/* Selected Employee */}
                  {selectedEmployee && (
                    <div style={{
                      marginBottom: '.7rem',
                      padding: '.5rem .7rem',
                      background: '#f1f5f9',
                      borderRadius: '6px',
                      fontSize: '.8rem'
                    }}>
                      Selected: <strong>{selectedEmployee.FullName}</strong>
                      <span
                        style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', float: 'right' }}
                        onClick={() => {
                          setSelectedEmployee(null);
                          setSearchValue("");
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  )}
                  <div className='geo-buttons'>
                    {/* Submit Button */}
                    <button
                      className="btn-og btn-brand"
                      style={{ width: '100%', marginTop: '1rem' }}
                      disabled={!selectedEmployee}
                      onClick={() => {
                        addLocationAssign(5,
                          selectedEmployee?.EmpId
                        );
                      }}
                    >
                      <i className="fa fa-check"></i>
                      Submit Selection
                    </button>
                    <button
                      className="btn-og btn-og-primary"
                      style={{ width: '100%', marginTop: '1rem' }}
                      disabled={!selectedEmployee}
                      onClick={() => {
                        removeLocationAssign(5,
                          selectedEmployee?.EmpId
                        );
                      }}
                    >
                      <i className="fa fa-check"></i>
                      Remove Selection
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Location info banner */}
          <div style={{ background: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: '12px', padding: '1rem 1.25rem', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', position: 'sticky', top: '13px' }}>
            <div style={{ width: '46px', height: '46px', background: 'var(--primary-light)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <i className="fa fa-map-marker" style={{ color: 'var(--primary)', fontSize: '1.2rem' }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: '1rem' }}>{locations.LocationName} </div>
              <div style={{ fontSize: '.78rem', color: 'var(--text-muted)' }}>{locations.Address}<strong style={{ color: '#16a34a' }}> {locations.LocationStatus ? 'Active' : 'Inactive'}</strong>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '.65rem', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ textAlign: 'center', padding: '.5rem .85rem', background: '#f8fafc', borderRadius: '8px', border: '1px solid var(--border)' }}>
                <div style={{ fontSize: '1.2rem', fontWeight: 800, color: 'var(--primary)' }}>{locations.MappedEmployees}</div>
                <div style={{ fontSize: '.68rem', color: 'var(--text-muted)', fontWeight: 600 }}>Assigned</div>
              </div>

            </div>
          </div>


        </div>
      </div>

      {/* Confirmation Modal */}
      {/* <div className="og-modal-overlay" style={{ display: showModal ? 'flex' : 'none' }}>
        <div className="og-modal og-modal-sm">
          <div className="og-modal-header">
            <i className="fa fa-users" style={{ color: 'var(--primary)', fontSize: '1.1rem' }}></i>
            <h5>{modalTitle}</h5>
            <button className="modal-close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="og-modal-body">
            <p>{modalMsg}</p>
            <div style={{ background: '#fff8f0', border: '1px solid #fcd9c5', borderRadius: '8px', padding: '.6rem .8rem', fontSize: '.76rem', color: '#c94a00' }}>
              <i className="fa fa-info-circle" style={{ marginRight: '.3rem' }}></i>
              Employees already assigned to this location will not be duplicated.
            </div>
          </div>
          <div className="og-modal-footer">
            <button className="btn-og btn-og-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button className="btn-og btn-og-primary" onClick={() => {
              if (modalAction) modalAction();
              setShowModal(false);
            }}>
              <i className="fa fa-check"></i> Confirm
            </button>
          </div>
        </div>
      </div> */}
    </div >
  );
};

export default Geotag_Employee_Assignment;

